import HomePage from "@/components/home/HomePage.vue";
import InformationAccountCustomer from "@/components/home/InformationAccountCustomer.vue";
import LoginCustomer from "@/components/home/LoginCustomer.vue";
import RegisterCustomerAccount from "@/components/home/RegisterCustomerAccount.vue";

const home = [
  {
    path: "/",
    component: HomePage,
    meta: { title: "Store Thanh Danh - Trang Chủ" },
    children: [
      {
        path: "/login-customer.html",
        component: LoginCustomer,
        meta: { title: "Đăng Nhập Khách Hàng - Store Thanh Danh" },
      },
      {
        path: "/lich-su-mua-hang.html",
        component: InformationAccountCustomer,
        meta: { title: "Lịch Sử Mua Hàng - Store Thanh Danh" , requiresAuth: true },
      },
      {
        path: "/register-customer.html",
        component: RegisterCustomerAccount,
        meta: { title: "Đăng Ký Tài Khoản Khách Hàng - Store Thanh Danh" },
      }
    ],
  },
];
export default home;
